import React, { useEffect } from "react"
import TMHBanner from "../../components/TMHBanner/TMHBanner"
import "./TermsConditionPage.scss"
import TermsData from "./data.json"
import { useTitle } from 'react-use'
import ReactGA from "react-ga4"

const TermsConditionPage = () => {
    useTitle("Terms of Use - The Movie House TV")
    useEffect(() => {
        ReactGA.send("pageview")
    })

    return (
        <TMHBanner classOption="only-gradient policy-page" isLogged={false}>
            <div className="terms-page">
                <h1 className="title">Terms of Use</h1>
                <div className="page-content">
                    <div className="desc">
                        {TermsData?.description.map((desc, desIndex) => (
                            <p key={"des_" + desIndex}>{desc}</p>
                        ))}
                    </div>
                    {TermsData?.terms.map((term, index) => (
                        <div className="term" key={index}>
                            <p className="term-header">
                                <span style={{ marginRight: "8px" }}> {index + 1}.</span>{" "}
                                {term.header}
                            </p>
                            {term?.paragraph.map((text, termIndex) => (
                                <p className="term-text" key={"term_" + termIndex} dangerouslySetInnerHTML={{ __html: text }}></p>
                            ))}
                        </div>
                    ))}
                </div>
                <nav className="policyPage__footer">
                    <a href="/tmh/#/privacy-policy" target="_blank">
                        Privacy policy
                    </a>
                    <a href="/tmh/#/terms-conditions" target="_blank">
                        Terms &#38; conditions
                    </a>
                    <a href="/tmh/#/about" target="_blank">
                        About The Movie House
                    </a>
                </nav>
            </div>
        </TMHBanner>
    )
}

export default TermsConditionPage
